import { render, staticRenderFns } from "./SubjectTeacherDetail.vue?vue&type=template&id=59b376a2"
import script from "../../controllers/subject_teacher/subject_teacher-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/subject_teacher/subject_teacher-detail.js?vue&type=script&lang=js&external"
import style0 from "./SubjectTeacherDetail.vue?vue&type=style&index=0&id=59b376a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports